/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_filter`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//delegation_details
export async function loadDelegationList(searchvalue) {
  if (searchvalue) {
    return await api
      .post(`/get_all_delegation_apply`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_all_delegation_apply`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

// PROCESS STATUS
export function loadProcessDetails(mode) {
  let payload = {
    status: "active",
    mode: mode,
  }

  return api
    .post(`/get_all_process_status`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//UPDATE DELEGATION
export async function updateDelegationRecord(update_Delegation) {
  console.log("inside saga", update_Delegation)
  return await api
    .post(`/editDelegation`, update_Delegation)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//UPDATE LPND
export async function updateLPNDRecord(statusDetails) {
  console.log("inside saga", statusDetails)
  return await api
    .put(`/update_lpnd_request`, statusDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//delete

export function deleteRecord(deleteData) {
  return api
    .put(`/deleteDelegation`, deleteData)
    .catch((error) => Promise.reject(error))
}

//UPDATE LPND
export async function applyDelegationDetailsList(applyDelegationDetails) {
  console.log("inside saga", applyDelegationDetails)
  return await api
    .post(`/applyDelegation`, applyDelegationDetails)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadEmployeeList,
  loadProcessDetails,
  updateLPNDRecord,
  updateDelegationRecord,
  deleteRecord,
  applyDelegationDetailsList,
}

export default remotes
